import { useNavigate } from "react-router-dom";
import AuthLayout from "@/features/auth-layout/AuthLayout";
import { ArrowTurnBackwardIcon, MailOpenIcon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import routes from "@/constants/routes";

const VerifyEmail = () => {
  const navigate = useNavigate();
  return (
    <AuthLayout
      icon={<HugeiconsIcon icon={MailOpenIcon} size={50} strokeWidth={1} color="#015FEE" />}
      title="Verifica tu email"
      subtitle={
        <>
          Haz clic en el enlace que te enviamos por email para activar tu cuenta.
          <br />
          ¿No recibiste el enlace?
        </>
      }
      primaryAction={{
        label: "Reenviar Email",
        onClick: () => {
          console.log("Resend email");
        },
      }}
      secondaryAction={{
        label: "Iniciar sesión",
        onClick: () => {
          console.log("Go to login");
          navigate(routes.login);
        },
        btnIcon: <HugeiconsIcon icon={ArrowTurnBackwardIcon} />,
      }}
    />
  );
};
export default VerifyEmail;
